import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { useState } from "react";
import { CurrencyProvider } from './components/Currencycontext';
import './App.css';

// Main site components
import LandingPage from "./components/landingpage/landingpage";
import Header from "./components/header-footer/header";
import Footer from "./components/header-footer/footer";
import Products from "./components/productspage/productspage";
import ProductDetails from "./components/product_details/productdetails";
import Cart from "./components/cartpage/cartpage";
import About from "./components/Aboutpage/aboutpage";
import InternshipPage from "./components/internshippage/intershippage";
import PCBDesign from "./components/pcb_designing/pcb_designing";
import Dashboard from "./components/accountpage/Myaccount";
import Wishlist from "./components/wishlist_page/wishlist";
import Contact from "./components/contactpage/contactform";
import ProgressTracker from "./components/cartpage/checkout";
import OrderCard from "./components/accountpage/myorders";
import LoginRegister from "./components/Login-signup/loginRegister";
import Gallerypage from "./components/Gallery_page/gallerypage";
//import PrintingCostCalculator from "./components/3dprinting/3dprinting";
import ComingSoonPopup from "./components/3dprinting/3dprinting";
import Loading1 from "./components/loading_animation/loading";

// Admin components
import AdminLayout from "./components/AdminPage/Admin_routes";
import Admindashboard from "./components/AdminPage/admin_dashboard";
import ManageCategory from "./components/AdminPage/admincontrols/manage_domain";
import ManageProducts from "./components/AdminPage/admincontrols/manage_products";
import ProductQnATable from "./components/AdminPage/bdmcontrols/questionmanager";
import PaymentApproval from "./components/AdminPage/inventorycontrols/inventory";
import DeliveryDetails from "./components/AdminPage/packagingcontrols/managepackage";
import OrdersPage from "./components/AdminPage/admincontrols/total_orders";
import InternshipApprovalTable from "./components/AdminPage/admincontrols/manageinternships";
import ManageSlots from "./components/AdminPage/internshipcontrols/manageslots";
import UpdateInternAmount from "./components/AdminPage/internshipcontrols/update_amount";
import ConfirmInterns from "./components/AdminPage/internshipcontrols/confirm_internships";
import InternshipTable from "./components/AdminPage/internshipcontrols/confirm_internships";
import RoleManager from "./components/AdminPage/admincontrols/adduser";
import AdminLogin from "./components/AdminPage/admin_login";
import PCBRequestsTable from "./components/AdminPage/admincontrols/pcb_design_requests";
import ReviewsTable from "./components/AdminPage/bdmcontrols/reviewmanager";
import ContactForm from "./components/contactpage/contactform";
import Terms from "./components/Terms&conditions/Terms&Conditions";
import MilestoneManager from "./components/AdminPage/admincontrols/addmilestone";
import GalleryManager from "./components/AdminPage/admincontrols/add_gallery_page";
 

//  Main site layout 
function MainLayout() {
  const location = useLocation();
  const hideHeaderOn = ["/"];
  const hideHeaderFooterOn = ["/"];
  const [loginTrigger, setLoginTrigger] = useState(0);


  return (
    <>
      {!hideHeaderOn.includes(location.pathname) && <Header loginTrigger={loginTrigger}/>}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<LoginRegister setLoginTrigger={setLoginTrigger}/>}/>
        <Route path="/products" element={<Products />} />
        <Route path="/product-details" element={<ProductDetails />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/internships" element={<InternshipPage />} />
        <Route path="/pcb-design" element={<PCBDesign />} />
        <Route path="/account" element={<Dashboard />} />
        <Route path="/wishlist" element={<Wishlist/>}/>
        <Route path="/contactus" element={<ContactForm/>}/>
        <Route path="/checkout" element={<ProgressTracker/>}/>
        <Route path="/myorders" element={<OrderCard/>}/>
        <Route path="/gallerypage" element={<Gallerypage/>}/>
        <Route path="/terms" element={<Terms/>}/>
        <Route path="/3dprinting" element={<ComingSoonPopup />} />
        {/* <Route path="/3dprinting" element={<Loading1 />} /> */}
      </Routes>
      {!hideHeaderFooterOn.includes(location.pathname) && <Footer />}
    </>
  );
}

// --- App ---
export default function App() {
  return (
    <Router>
      <CurrencyProvider>
        <Routes>
          {/* Admin routes */}
          <Route path="/Rc_admin" element={<AdminLogin />} />
          <Route path="/rc_admin_panel/*" element={<AdminLayout />}>
            <Route index element={<Admindashboard />} />
            <Route path="domain" index element={<ManageCategory/>}/>
            <Route path="products"index element={<ManageProducts/>}/>
            <Route path="questions"index element={<ProductQnATable/>}/>
            <Route path="inventory"index element={<PaymentApproval/>}/>
            <Route path="packaging"index element={<DeliveryDetails/>}/>
            <Route path="total_orders"index element={<OrdersPage/>}/>
            <Route path="approveinternships" index element={<InternshipApprovalTable/>}/>
             <Route path="slots"index element={<ManageSlots/>}/>
             <Route path="amountupdate"index element={<UpdateInternAmount/>}/>
             <Route path="confirminternship"index element={<InternshipTable/>}/>
             <Route path="addusers" index element={<RoleManager/>}/>
            <Route path="pcbrequests" index element={<PCBRequestsTable/>}/>
            <Route path="reviews" index element={<ReviewsTable/>}/>
            <Route path="addmilestone"index element={<MilestoneManager/>}/>
            <Route path="addgallerypage" index element={<GalleryManager/>}/>
          </Route>

          {/* Main site routes */}
          <Route path="/*" element={<MainLayout />} />
        </Routes>
      </CurrencyProvider>
    </Router>
  );
}
